import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-39839512"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("首页");

var _hoisted_2 = /*#__PURE__*/_createTextVNode("页面配置");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("基础配置");

var _hoisted_4 = {
  style: {
    "text-align": "left"
  }
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "编辑公告", -1);
});

var _hoisted_6 = /*#__PURE__*/_createTextVNode("保存");

import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    name: "Config";

    var textarea = ref("\u5F00\u653EAPI-2.0\u6B63\u5F0F\u4E0A\u7EBF\uFF0C\u539F<a href=\"/v1\">API-1.0\u7248\u672CSpring-Boot SSM</a>\u9879\u76EE\u5DF2\u6210\u4E3A\u5386\u53F2\uFF0C\u6B64\u6B21\u66F4\u65B0\u540E\uFF0C\u589E\u52A0\u8BBF\u95EE\u9891\u7387\u9650\u5236\uFF0C\u9632\u6B621.0\u7248\u672C\u51FA\u73B0\u7684\u6076\u610F\u653B\u51FB\u5BFC\u81F4\u670D\u52A1\u5F02\u5E38\u95EE\u9898\uFF0C\u6570\u636E\u66F4\u65B0\u9646\u7EED\u8FDB\u884C\u4E2D...");

    var saveNotice = function saveNotice() {
      console.log("保存公告", textarea.value);
    };

    return function (_ctx, _cache) {
      var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_breadcrumb_item, {
            to: {
              path: '/admin'
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          }), _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
        modelValue: textarea.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return textarea.value = $event;
        }),
        maxlength: "1000",
        placeholder: "请输入公告内容...",
        "show-word-limit": "",
        type: "textarea",
        rows: 20
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "save-notice",
        type: "primary",
        onClick: saveNotice
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      })])], 64);
    };
  }
});